module.exports = __webpack_public_path__ + "static/media/datenschutzordnung.8c6aa7b2.pdf";